export const TABS = {
  FOLLOWUP: 'FOLLOWUP',
  HISTORY: 'HISTORY',
}
